module.exports = __webpack_public_path__ + "img/hero-blockspace.b13c7ae2.png";